import React from 'react';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import { Controller } from 'react-hook-form';
import FormHelperText from '@mui/material/FormHelperText';
import { CommonDropDownStyle } from '../../ui/styled';

const InputDropdown = (props) => {
  const {
    name,
    control,
    label,
    options,
    defaultId,
    errors,
    helperText,
    disabled,
    register,
    valueAsKey,
    monthId,
    cssOrScssList,
  } = props;

  const generateSingleOptions = () => {
    return options?.map((item, index) => {
      return (
        <MenuItem
          key={index}
          value={monthId ? item.mthId : cssOrScssList ? item.cntId : item.id}
        >
          {item.value}
          {monthId && item.mthId}
          {valueAsKey && item.key}
          {cssOrScssList && item.contactName}
        </MenuItem>
      );
    });
  };

  return (
    <CommonDropDownStyle>
      <InputLabel>{label}</InputLabel>
      <Controller
        register={register}
        render={({ field: { onChange, onBlur, value } }) => (
          <Select
            defaultValue={defaultId}
            onChange={onChange}
            onBlur={onBlur}
            value={value}
            error={errors}
            disabled={disabled}
          >
            {generateSingleOptions()}
          </Select>
        )}
        control={control}
        name={name}
      />
      <FormHelperText style={{ color: '#ff4d4f' }}>{helperText}</FormHelperText>
    </CommonDropDownStyle>
  );
};

export default InputDropdown;
